import { Injectable } from '@angular/core';
import axios from 'axios';
import { GlobalService } from './global.service';

@Injectable({
    providedIn: 'root'
})

export class ApiClientService {
    public apiAddress: string;

    constructor(private globalService: GlobalService) { }

    
    public setApiAddress(address) {
        return this.apiAddress = address;
    }

    public async get(route: string, params: any = {}, headers: any = {}){
        try {
            const response = await axios.get(`${this.apiAddress}${route}`, {
                params: {...params},
                headers: {'content-type': 'application/json', ...headers},
            });
            return response.data;
        } catch (error) {
            //console.log(error)
            return {
                error
            }
        }
    }

    public async getStaticFiles(route: string){
        try {
            const response = await axios.get(route);
            return response.data;
        } catch (error) {
            //console.log(error)
            return {
                error
            }
        }
    }
    
    public async post(route: string, data: any = {}, headers: any = {}){
        try {
            await axios.post(`${this.apiAddress}${route}`, data);
        } catch (error) {
            //console.log(error)
            return {
                error
            }
        }
    }
}